import { useQuery } from '@tanstack/react-query';
import { useCallback } from 'react';
import envVars from '../../../constants/envVars';
import useRequest from '../../../hooks/useRequest';
import { CHECKIN_MEMBERS_KEY } from './constants';
import { CheckinMembersResponse, MemberSortField, MemberSortOrder } from '../types';

export type GetCheckinMembersParams = {
    search?: string;
    offset?: string;
    limit?: number;
    date_type?: string;
    checkin_status?: string;
    checkin_date?: string;
    state?: string;
    care_manager_ids?: string;
    sort_by?: MemberSortField;
    sort_order?: MemberSortOrder;
};

const useGetCheckinMembers = (
    query: GetCheckinMembersParams,
    options: { enabled?: boolean } = {}
) => {
    const req = useRequest();

    const action = useCallback(() => {
        return req<CheckinMembersResponse>({
            url: `${envVars.API_COMMERCE_HOSTNAME}enterprise/checkin-members`,
            query: {
                ...(query.search && { search: query.search }),
                ...(query.offset && { offset: query.offset }),
                ...(query.limit && { limit: query.limit }),
                ...(query.date_type && { date_type: query.date_type }),
                ...(query.checkin_status && { status: query.checkin_status }),
                ...(query.checkin_date && { date_type: query.checkin_date }),
                ...(query.state && { state: query.state }),
                ...(query.care_manager_ids && { care_manager_ids: query.care_manager_ids }),
                ...(query.sort_by && { sort_by: query.sort_by, sort_order: query.sort_order })
            }
        });
    }, [req, query]);

    return useQuery({
        queryFn: action,
        queryKey: [CHECKIN_MEMBERS_KEY, query],
        enabled: options.enabled !== false
    });
};

export default useGetCheckinMembers;
